import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestData({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'transferenciaareiasilo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteData({ payload }) {
  try {
    const { id, params } = payload;

    yield call(api.delete, `transferenciaareiasilo/${id}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.post, 'transferenciaareiasilo', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `transferenciaareiasilo/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'transferenciaareiasilo', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'transferenciaareiasilo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest('@transferenciaAreiaSilo/DATA_IN_REQUEST', requestData),
  takeLatest('@transferenciaAreiaSilo/DELETE_DATA', deleteData),
  takeLatest('@transferenciaAreiaSilo/SUCCESS_REMOVE', requestData),
  takeLatest('@transferenciaAreiaSilo/STORE_DATA', store),
  takeLatest('@transferenciaAreiaSilo/FIND_DATA', find),
  takeLatest('@transferenciaAreiaSilo/UPDATE_DATA', update),
  takeLatest('@transferenciaAreiaSilo/RECORD_FILTERING', applyedFilters),
]);
